/**
 * 长期记忆开关状态管理。
 * 用 localStorage 记住当前浏览器是否允许聊天接口注入用户记忆。
 */
import { ref } from "vue";
import { StorageKey } from "~/enums";

const MEMORY_ENABLED_STORAGE_KEY = StorageKey.AI_CHAR_MEMORY_ENABLED;
const memoryEnabled = ref(true); // 默认启用记忆
let initialized = false; // 防止重复初始化

/**
 * 初始化记忆设置，从 localStorage 加载状态。
 */
function initMemorySettings() {
  if (initialized || !import.meta.client) {
    return;
  }

  const storedValue = localStorage.getItem(MEMORY_ENABLED_STORAGE_KEY); // 从 localStorage 获取存储的值
  memoryEnabled.value = storedValue !== "false";
  initialized = true;
}

export function useMemorySettings() {
  initMemorySettings();

  /**
   * 设置记忆是否启用
   */
  const setMemoryEnabled = (enabled: boolean) => {
    memoryEnabled.value = enabled;
    if (import.meta.client) {
      localStorage.setItem(MEMORY_ENABLED_STORAGE_KEY, String(enabled));
    }
  };

  /**
   * 获取记忆是否启用
   */
  const isMemoryEnabled = () => {
    initMemorySettings();
    return memoryEnabled.value;
  };

  return {
    memoryEnabled,
    setMemoryEnabled,
    isMemoryEnabled,
  };
}
